<template>
  <div class="workspace_leftContainer">
    <div
      class="main_left"
      ref="main_left"
      :style="{ height: `calc(${containerHeight}px - 6.94vw)` }"
    >
      <span class="workspace_topAbs" v-if="themeItemData">
        <span class="topLeft">
          <span
            v-if="
              fileData &&
              fileData.posterPermissions &&
              fileData.posterPermissions.includes('edit')
            "
            class="workspace_btn mr15"
            v-text="isPosterEditFlag ? '保存' : '编辑'"
            @click="clickPosterEditBtn(isPosterEditFlag)"
          ></span>
          <span class="btnRow" v-show="curPicItem">
            <span class="btnRow_title" v-text="'缩放'"></span>
            <template v-if="curPicItem && curPicItem.useScale">
              <el-input-number
                v-model="curPicItem.useScale"
                :precision="2"
                :step="0.01"
                :max="10"
                :min="0.01"
                @change="useScaleChange"
              ></el-input-number>
            </template>
          </span>
        </span>
        <span class="topRight">
          <span class="picSizeSelect" v-show="picSizeArr">
            <span class="theme_select">
              <el-select
                v-model="workspaceParams.curSizeId"
                placeholder="请选择海报尺寸"
                popper-class="theme_select_popper"
                :popper-append-to-body="false"
                @change="changePicSizeHandler"
              >
                <el-option
                  v-for="item in picSizeArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
          </span>
        </span>
      </span>
      <span class="workspace_bottomAbs" v-if="themeItemData">
        <span class="bottomLeft">
          <span
            v-if="fileData && fileData.fileList && fileData.fileList.length > 0"
            class="workspace_btn"
            v-text="'更换素材'"
            @click="openBaseFillSlotDialog('sourceMaterial')"
          ></span>
        </span>
        <span class="bottomRight">
          <span
            v-if="fileData && fileData.fileList && fileData.fileList.length > 0"
            class="workspace_btn mr15"
            v-text="'取消选图'"
            @click="clickCancelActPic('init')"
          ></span>
          <span
            class="workspace_btn"
            v-text="'下载'"
            @click="localDownloadPic()"
          ></span>
        </span>
      </span>
      <span
        class="workspace_main"
        ref="workspace_main"
        :style="computedWorkspaceMainStyle"
      >
        <span class="defaultPic">
          <span class="pic_icon el-icon-picture"></span>
          <span class="textArea">
            <span v-text="'比赛暂无数据，请选择新的比赛'"></span>
            <!-- <span class="highColor" v-text="'本地上传'"></span>
            <span v-text="'或者'"></span>
            <span class="highColor" v-text="'AI生成'"></span> -->
          </span>
        </span>
        <span class="workspace_view disable-touch-callout" ref="workspace_view">
          <posterThemeItem
            v-if="
              fileData &&
              fileData.sizeClassName &&
              themeItemData &&
              cssDynamicObj
            "
            :currThemeObj="currThemeObj"
            :sourceData="fileData"
            :themeItemData="themeItemData"
            :cssDynamicObj="cssDynamicObj"
            :sizeClassName="fileData.sizeClassName"
            :isEditFlag="isPosterEditFlag"
            @curPicItemEvent="curPicItemEventHandler"
          ></posterThemeItem>
        </span>
      </span>
    </div>
    <div class="dialog_pop">
      <!-- 更换海报素材 弹窗  -->
      <base_fillSlot_dialog
        :dialogItem="dialogItem_sourceMaterial"
        :checkListNum="
          fileData && fileData.fileList ? fileData.fileList.length : 1
        "
        :isHideFooter="true"
        :headerAreaRightArr="dialogItem_headerAreaRightArr"
        @headerAreaRightClickEvent="headerAreaRightClickEvent"
        @dialogCancelEvent="dialogCancelEventHandler"
      >
        <template v-slot:checkList>
          <div
            class="editPicRowItem_list"
            v-for="(fileItem, index) in fileData.fileList"
            :key="fileItem.uid"
          >
            <editPicRowItem
              :currThemeObj="currThemeObj"
              :axiosBaseUrl="axiosBaseUrl"
              :rowItem="fileItem"
              :uploadType="uploadType"
              :indexArr="[fileData.fileList.length, index]"
              @loactionPreviewEvent="loactionPreviewEventHandler"
              @cropPreviewEvent="cropPreviewEventHandler"
              @clickInputFileEvent="clickInputFileEventHandler"
              @cutoutImageEvent="cutoutImageEventHandler"
              @changeItemPicEvent="changeItemPicEventHandler"
            ></editPicRowItem>
          </div>
        </template>
      </base_fillSlot_dialog>

      <!-- 智能抠图弹窗 -->
      <base_fillSlot_dialog
        :dialogItem="dialogItem_cutoutImage"
        :checkListNum="1"
        :isHideFooter="true"
        @dialogCancelEvent="dialogCancelEventHandler"
      >
        <template v-slot:checkList>
          <div class="cutoutImage_container">
            <span class="picVeiwList">
              <span
                class="picImageSpan"
                v-for="picItem in curr_cutoutImageArr"
                :key="picItem.key"
              >
                <img v-if="picItem.url" :src="picItem.url" :ref="picItem.key" />
              </span>
            </span>
            <span class="btnList">
              <span
                class="btnArea"
                v-for="(item, btnIndex) in cutoutImage_btnArr"
                :key="item.key"
              >
                <span class="picType" v-text="item.picType"></span>
                <span
                  class="workspace_btn"
                  v-text="item.name"
                  :class="curr_cutoutImageArr[btnIndex].url ? '' : 'notClick'"
                  @click="cutoutImage_btn(item)"
                ></span>
              </span>
            </span>
          </div>
        </template>
      </base_fillSlot_dialog>
    </div>
    <div class="cropperPop" v-if="showCropperPop">
      <VueCropper
        :imgFile="editFile.url"
        :uploadImageType="'base64'"
        :autoCropWidth="cropperOpt.autoCropWidth"
        :autoCropHeight="cropperOpt.autoCropHeight"
        :setRatioFlag="setRatioFlag"
        @closeCropper="closeCropperHandler"
        @upload="uploadHanlder"
        @changeSetRatioFlagEvent="changeSetRatioFlagEventHandler"
      ></VueCropper>
    </div>

    <input
      class="uploadInput"
      :id="uploadDom_id"
      type="file"
      :accept="fileAccept"
      @change="loadFileEvent"
      style="display: none"
    />
  </div>
</template>
<script>
// 编辑工作站 左侧区域
// 更换图片|裁切图片 功能都只对 （jpg|jpeg|webp） 压缩生效，测试验证过的只有（jpg|jpeg），webp格式理论上是可以的没有实际验证过；对png格式的不生效
import { https_dataPoster_cutoutImage } from '@api/platfrom_dataPoster_api.js'
import dataPoster_base_data_mixin from '@mixins/dataPoster_base_data'
import html2canvas from 'html2canvas'
import VueCropper from '@/components/base/VueCropper.vue'
// import HTML_BAR_INDICATOR_ITEM from '@components/dataPoster/html/HTML_BAR_INDICATOR_ITEM/index.vue'
import base_fillSlot_dialog from '@components/base/base_fillSlot_dialog.vue'
import editPicRowItem from '@components/platfromBase/dataPoster/editPic_row_item/index.vue'
import posterThemeItem from '@components/platfromBase/dataPoster/posterThemeItem/index.vue'
import profile_data_mixins from './profile_data.js' //映射主题组件目录
import { compressBase64Image, getBase64ImageSize } from '@utils/utils'
export default {
  name: 'workspace_leftContainer',
  mixins: [dataPoster_base_data_mixin, profile_data_mixins],
  components: {
    VueCropper,
    base_fillSlot_dialog,
    editPicRowItem,
    // HTML_BAR_INDICATOR_ITEM,
    posterThemeItem,
  },
  props: {
    containerHeight: {
      type: Number,
      default: 0,
    },
    picSizeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    posterBaseInfor: {
      type: Object,
      default: () => ({
        posterName: '',
        posterId: '',
      }),
    },
    themeItemData: {
      type: Object,
      default: () => ({
        renderData: {},
      }),
    },
  },
  watch: {
    async picSizeArr(newVal, oldVal) {
      console.debug('picSizeArr:', newVal)
      if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.workspaceParams = {
          curSizeId: newVal[0].id,
        }
        await this.makeFileDataHandler(
          newVal[0].posterGraphId,
          newVal[0].posterGraphJsonMap
        )
        this.dialogItem_headerAreaRightArr = [
          {
            name: '添加图片',
            key: 'addIamge',
          },
        ]
        this.curPicItem = null
      }
    },
    immediate: true,
    deep: true,
  },
  data() {
    return {
      workspaceParams: {
        curSizeId: '', //目前选中的尺寸 id
      },
      isPosterEditFlag: false, //顶部编辑按钮；true:编辑海报；false:不编辑海报
      dialogItem_headerAreaRightArr: null,
      dialogItem_sourceMaterial: null, // 点击【更换素材】时，弹窗对象
      dialogItem_cutoutImage: null, // 点击【智能抠图】时，弹窗对象
      cutoutImage_btnArr: [
        {
          key: 'cutoutImageBtn',
          name: '智能抠图',
          picType: '原始图片',
        },
        {
          key: 'useBtn',
          name: '确认使用',
          picType: '最终图片',
        },
      ],
      showCropperPop: false, // 是否显示裁图弹窗
      editFile: { url: '' }, // 临时存储截图的对象
      cropperOpt: {}, //设置裁切图片的参数，比如固定裁切比例
      setRatioFlag: false, // 设置裁切初始化为 自由裁切，兼容哪些没有设置宽高的；true:自由裁切，需要设置宽高
      uploadType: 'uploadImage',
      jionUrlSymbols: ',', //用来区分多个图片链接的符号 this.item.value: 'url1'||'url1,url2,url3'
      curr_cutoutImageArr: null, //如果有数据就是2个元素[原始图片,扣完图片]

      fileData: null,
      cssDynamicObj: null,
      curPicItem: null, // 海报子组件中传递的回来的选中的图片对象
      uploadDom_id: '',
      imageSizeKbLimitNum: 500, // 更换图片时如果图片大于500kb则压缩，计算的大小有误差
    }
  },
  computed: {
    fileAccept() {
      let accept = ''
      if (this.uploadType === 'uploadImage') {
        accept = '.jpg,.jpeg,.png,.git,.webp,.heic'
      } else if (this.uploadType === 'uploadVideo') {
        accept = '.avi,.mp4,.3gp,.mkv,.mpg,.mpeg,.rmvb,.wmv,.flv,.mov' //.ts,
      } else if (this.uploadType === 'uploadAudio') {
        accept = '.mp3,.wma,.wav,.aac,.ra,.m4a,.flac,.ape,.ac3,.amr,.caf,.acm'
      } else if (this.uploadType === 'uploadFile') {
        accept = '.xlsx, .pdf, .txt, .doc, .docx, .xls, .rar, .zip,'
      }
      return accept
    },
    currPicSize() {
      let currPicSizeArr = []
      const { curSizeId } = this.workspaceParams
      this.picSizeArr.forEach((sizeItem) => {
        if (sizeItem.id === curSizeId) {
          currPicSizeArr = sizeItem.name.split('*')
        }
      })
      return currPicSizeArr
    },
    computedWorkspaceMainStyle() {
      // 计算图片dom的宽高
      // console.debug(
      //   'computedWorkspaceMainStyle:',
      //   this.containerHeight,
      //   this.currPicSize
      // )
      if (
        this.containerHeight &&
        this.currPicSize &&
        this.currPicSize.length > 0
      ) {
        let maxHpx = 0
        let maxWpx = 0
        const style = {}
        if (this.$refs.main_left) {
          maxWpx = this.$refs.main_left.offsetWidth
          maxHpx = this.$refs.main_left.offsetHeight
          let picSizeArr = this.currPicSize
          const rateWH = picSizeArr[0] / picSizeArr[1]
          const arrWH = []
          if (rateWH * maxHpx > maxWpx) {
            // 计算得到的宽度不够，以宽度为标准计算高度
            style.width = `100%`
            style.height = `${Math.round(maxWpx / rateWH)}px`
            arrWH.push(maxWpx, Math.round(maxWpx / rateWH))
          } else {
            //以高度为标准计算宽度
            style.width = `${Math.round(rateWH * maxHpx)}px`
            style.height = `${maxHpx}px`
            arrWH.push(Math.round(rateWH * maxHpx), maxHpx)
          }

          this.setMixtmtVw(arrWH)
          console.debug('style:', style)
        }
        return style
      } else {
        return {
          opacity: 0,
        }
      }
    },
  },
  created() {
    // 上传图片input 唯一id
    this.uploadDom_id = this.guid('m-upload-file-xxxxxx-4xxx-yxxx')
    console.debug('guid:', this.guid('m-dataPoster-file-id-xxxxxx-xxxx-xxxx'))
    // 开启拖拽功能
  },
  methods: {
    async changePicSizeHandler(curSizeId) {
      // 切换尺寸
      console.debug(curSizeId)
      // let fileData = JSON.parse(JSON.stringify(this.fileData))
      let posterId = null,
        posterGraphJsonMap = null
      this.picSizeArr.forEach((sizeItem) => {
        if (sizeItem.id === curSizeId) {
          posterId = sizeItem.posterGraphId
          posterGraphJsonMap = JSON.parse(
            JSON.stringify(sizeItem.posterGraphJsonMap)
          )
        }
      })
      if (posterId && posterGraphJsonMap) {
        await this.makeFileDataHandler(
          posterId,
          posterGraphJsonMap,
          'changePicSize'
        )
        this.curPicItem = null
      }
    },
    setMixtmtVw(arrWH) {
      console.debug('setMixtmtVw:', arrWH)
      this.cssDynamicObj = this.getMixvw(arrWH[0], arrWH[1])
    },
    useScaleChange(scaleVal) {
      console.debug(scaleVal, this.fileData)
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      const fileList = fileData.fileList.map((fileItem) => {
        if (fileItem.uid === this.curPicItem.uid) {
          fileItem.useScale = scaleVal
        }
        return fileItem
      })
      fileData.type = 'changePicScale'
      fileData.fileList = fileList
      this.fileData = fileData
    },
    curPicItemEventHandler(childData) {
      // 子组件必须函数
      const { data: curPicItem } = childData
      console.debug('curPicItem leftCon:', curPicItem, this.curPicItem)
      // 重新赋值给 fileData
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      let fileList = fileData.fileList.map((fileItem) => {
        if (fileItem.uid === curPicItem.uid) {
          fileItem = JSON.parse(JSON.stringify(curPicItem))
          this.curPicItem = fileItem
        } else {
          // fileItem.isDraggable = false
          fileItem.actState = ''
        }
        return fileItem
      })

      fileData.type = 'changeFromChild' //每次子组件传事件回来都置为changeFromChild
      fileData.fileList = fileList
      this.fileData = fileData
      console.debug('changeFromChild', this.fileData, this.curPicItem)
    },
    clickCancelActPic(type) {
      this.cancelActPic(type)
    },
    cancelActPic(type) {
      // 取消画板中选中的图片，去掉图片上面的描边
      this.curPicItem = null
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      const fileList = fileData.fileList.map((fileItem) => {
        // fileItem.isDraggable = false
        fileItem.actState = ''
        return fileItem
      })
      fileData.fileList = fileList
      fileData.type = type
      this.fileData = fileData
    },
    openBaseFillSlotDialog(mode) {
      if (mode === 'sourceMaterial') {
        this.dialogItem_sourceMaterial = {
          isDialogFlag: true,
          dialogType: 'check',
          dialogMode: 'sourceMaterial', // ['sourceMaterial':更换素材弹窗, 'cutoutImage':智能抠图弹窗]
          dialogText: '更换海报素材',
        }
      } else if (mode === 'cutoutImage') {
        this.dialogItem_cutoutImage = {
          isDialogFlag: true,
          dialogType: 'check',
          dialogMode: 'cutoutImage', // ['sourceMaterial':更换素材弹窗, 'cutoutImage':智能抠图弹窗]
          dialogText: '智能抠图',
        }
      }
    },
    clickPosterEditBtn(flag) {
      this.isPosterEditFlag = !flag
    },
    headerAreaRightClickEvent(childData) {
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      let newFileItem = JSON.parse(JSON.stringify(fileData.fileList[0]))
      newFileItem.styleItem.left = formatStyleItem(newFileItem.styleItem.left)
      newFileItem.styleItem.top = formatStyleItem(newFileItem.styleItem.top)
      newFileItem.styleItem.zIndex = fileData.maxZindex_fileList
      function formatStyleItem(valPer) {
        let newVal,
          ceilType = 0
        let ceilArr = ['', '%', 'px']
        if (valPer.indexOf('%') > -1) {
          newVal = valPer.split('%')[0]
          ceilType = 1
        } else if (valPer.indexOf('px') > -1) {
          newVal = valPer.split('px')[0]
          ceilType = 2
        } else {
          newVal = valPer
        }
        newVal = newVal - 0
        let addDiffVal = 0,
          limit = 0
        if ([0, 1].includes(ceilType)) {
          // 单位是 % | 没有单位比如 直接是 0
          addDiffVal = 1
          limit = 50
        } else if (ceilType === 2) {
          // 单位是 px
          addDiffVal = 10
          limit =
            newFileItem.picWidth > newFileItem.picHeight
              ? newFileItem.picHeight
              : newFileItem.picWidth //取2者最小值
        }
        if (newVal > limit) {
          newVal = newVal - addDiffVal
        } else {
          newVal = newVal + addDiffVal
        }

        return `${newVal}${ceilArr[ceilType]}`
      }
      let uid = this.guid(
        `m-dataPoster-file-${fileData.posterId}-xxxxxx-xxxx-xxxx`
      )
      let name = newFileItem.name
      let mergeObj = {
        name: '新增图片',
        uid,
        // isDraggable: false, //存储是否处于拖拽状态
        className: uid, //'playerLogo', //这个className不能重复，相当于视图里面的唯一id
        actState: '', //图片的状态 ['', 'click', 'longPress']移动时停留在 longPress 的样式
      }
      fileData.fileList.forEach((fileItem) => {
        fileItem.styleItem.zIndex--
      })
      fileData.fileList.unshift(Object.assign({}, newFileItem, mergeObj))
      fileData.type = 'addIamge'
      this.fileData = fileData
    },
    async dialogCancelEventHandler(childData) {
      const { mode, data } = childData
      // 弹窗中【取消|关闭弹窗】按钮，不是分享按钮中的取消创建主题
      // console.debug('dialogCancelEventHandler:', this.themeItem, val)
      if (mode === 'sourceMaterial') {
        this.dialogItem_sourceMaterial = null
      } else if (mode === 'cutoutImage') {
        this.dialogItem_cutoutImage = null
      }
    },
    cutoutImageEventHandler(childData) {
      // 抠图
      console.debug('cutoutImageEventHandler:', childData)
      let orginPic = JSON.parse(JSON.stringify(childData.data))
      //   转化成base64格式存储
      orginPic.key = 'orginImage'
      this.curr_cutoutImageArr = [
        orginPic,
        {
          key: 'cutoutImage',
          name: orginPic.name,
          percentage: 0,
          status: '', //'location':刚从本地读取文件到浏览器未上传； 'progress':正在向oss上传；'success':已经上传成功
          size: 0,
          useScale: 1, //抠图完成默认比例是1
          picWidth: orginPic.picWidth,
          picHeight: orginPic.picHeight,
          raw: {},
          uid: orginPic.uid,
          // url: 'https://hyper-sports-res.mixtmt.com/app/competition/small/SOG.png',
          url: '',
          submitVal: '', //不要oss域名的路径
          absOssUrl: '', //oss生产的在线地址
        },
      ]
      this.openBaseFillSlotDialog('cutoutImage')
    },
    changeItemPicEventHandler(childData) {
      const type = childData.type
      let rowItem = JSON.parse(JSON.stringify(childData.data))
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      if (type === 'showPic') {
        fileData.fileList.forEach((fileItem) => {
          if (fileItem.uid === rowItem.uid) {
            fileItem.isShowPic = !rowItem.isShowPic
          }
        })
      } else if (type === 'changeImageName') {
        fileData.fileList.forEach((fileItem) => {
          if (fileItem.uid === rowItem.uid) {
            fileItem.name = rowItem.name
          }
        })
      } else if (type === 'moveUp') {
        rowItem.styleItem.zIndex++
        if (rowItem.styleItem.zIndex > fileData.maxZindex_fileList) {
          rowItem.styleItem.zIndex = fileData.maxZindex_fileList
        }
        const newList = []
        fileData.fileList.forEach((fileItem) => {
          if (fileItem.styleItem.zIndex === rowItem.styleItem.zIndex) {
            fileItem.styleItem.zIndex--
            newList.push(rowItem)
          }
          if (fileItem.uid !== rowItem.uid) {
            newList.push(fileItem)
          }
        })
        fileData.fileList = newList
        fileData.type = type
      } else if (type === 'moveDown') {
        rowItem.styleItem.zIndex--
        if (rowItem.styleItem.zIndex < 0) {
          rowItem.styleItem.zIndex = 0
        }
        const newList = []
        fileData.fileList.forEach((fileItem) => {
          if (fileItem.styleItem.zIndex === rowItem.styleItem.zIndex) {
            fileItem.styleItem.zIndex++
            newList.push(fileItem)
            newList.push(rowItem)
          } else {
            if (fileItem.uid !== rowItem.uid) {
              newList.push(fileItem)
            }
          }
        })
        fileData.fileList = newList
        fileData.type = type
      }
      this.fileData = fileData
    },
    cutoutImage_btn(item) {
      if (item.key === 'cutoutImageBtn') {
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
        const imgInfor = {
          width: this.curr_cutoutImageArr[0].picWidth,
          height: this.curr_cutoutImageArr[0].picHeight,
        }
        // 点击抠图时，curr_cutoutImageArr已经有存在了
        this.convertImageToBase64(
          this.$refs[this.curr_cutoutImageArr[0].key][0],
          imgInfor,
          (base64) => {
            let params = {
              width: imgInfor.width,
              height: imgInfor.height,
              base64,
            }
            this.cutoutImage(params)
          }
        )
      } else if (item.key === 'useBtn') {
        if (!this.curr_cutoutImageArr[1].url) return //如果最终图片没有值，则改按钮不能点击置灰
        const curr_cutoutImageArr = this.curr_cutoutImageArr
        let fileData = JSON.parse(JSON.stringify(this.fileData))
        const fileList = fileData.fileList.map((fileItem) => {
          if (fileItem.uid === curr_cutoutImageArr[0].uid) {
            fileItem.url = curr_cutoutImageArr[1].url
            fileItem.urlBase64 = curr_cutoutImageArr[1].url
          }
          return fileItem
        })
        fileData.fileList = fileList
        this.fileData = fileData
        // 关闭弹窗
        this.dialogCancelEventHandler({ mode: 'cutoutImage', data: null })
      }
    },
    convertImageToBase64(imgElement, imgInfor, callback) {
      // 有图片生成base64
      // 创建一个Canvas对象
      console.debug('imgElement:', imgElement)
      const canvas = document.createElement('canvas')
      canvas.style.width = `${imgInfor.width}px`
      canvas.style.height = `${imgInfor.height}px`
      canvas.width = imgInfor.width
      canvas.height = imgInfor.height

      // 绘制图片到Canvas对象上
      const ctx = canvas.getContext('2d')
      ctx.drawImage(imgElement, 0, 0, canvas.width, canvas.height)

      // 将Canvas转换为Base64字符串
      const base64String = canvas.toDataURL()

      // 清除没用的dom
      if (canvas.remove) {
        canvas.remove()
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas)
      }

      // 调用回调函数并传递Base64字符串
      callback(base64String)
    },
    clickInputFileEventHandler(data) {
      console.debug('locationUploadPic', data)
      if (!this.uploadDom) {
        console.debug('clickInputFileEventHandler:', data)
        this.uploadDom = document.getElementById(this.uploadDom_id)
      }
      // 先清空
      this.uploadDom.value = ''
      this.uploadDom.click()
      this.curUploadFileItem = data.item
    },
    loadFileEvent(event) {
      // input 更换图片
      console.debug('loadFileEvent:', event)
      if (!this.uploadDom) {
        this.uploadDom = document.getElementById(this.uploadDom_id)
      }
      const file = this.uploadDom.files[0]
      //   this.uploadDom.value = ''
      this.packageFileList(file)
    },
    guid(format) {
      // 'm-upload-file-xxxxxx-4xxx-yxxx'
      return format.replace(/[x,y]/g, function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    computFileName(fileName) {
      console.debug(fileName)
      const fileNameArr = fileName.split('?')
      return fileNameArr[0]
    },
    closeCropperHandler() {
      // 关闭图片裁切弹窗
      this.clickUploadBtn(true)
    },
    changeSetRatioFlagEventHandler(flag) {
      this.setRatioFlag = flag
    },
    async uploadHanlder(updateData) {
      // 保存裁切图片的回调
      console.debug('uploadHanlder:', updateData, this.fileData, this.editFile)
      const { data: base64, setRatioFlag } = updateData
      if (!base64) {
        console.debug(updateData.tipText)
        return
      }
      const { width, height } = await this.base64ToImageWHpxAsync(base64)
      let dataFile = this.dataURLtoFile(base64, this.editFile.name)
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      if (fileData.fileList && fileData.fileList.length > 0) {
        fileData.fileList.forEach((item) => {
          if (item.uid === this.editFile.uid) {
            item.url = base64
            item.urlBase64 = item.url
            item.picWidth = width
            item.picHeight = height
            item.useScale = 1 // 所有新图的比例默认都是1
            // 默认走 原比例裁图
            if (setRatioFlag) {
              // 按原比例裁切
              item.picRateW = item.orginPicRateWH[0]
              item.picRateH = item.orginPicRateWH[1]
            } else {
              // 自由裁切
              const picRateWH = this.updateImageDisplayRatio(
                width,
                height,
                item
              )
              item.picRateW = picRateWH[0]
              item.picRateH = picRateWH[1]
            }

            item.size = dataFile.size
            item.raw = dataFile
          }
        })
      }
      this.fileData = fileData
      console.debug('uploadHanlder:', this.fileData, this.cssDynamicObj)

      this.closeCropperHandler()
      //   console.debug(dataFile)
      // this.uploadToOss(dataFile)
    },
    updateImageDisplayRatio(width, height, orginFileItem) {
      // 新图的 width, height
      // 当图片的宽高比例发生变化时，执行此函数，重新设置 [picRateW, picRateH]
      let ratio = 1 // 实际画板与原图的系数比（取宽的或者取高的）
      let useScale = 1 // 新图宽高统一缩放的比例
      const designDraftSize_orgin = this.fileData.designDraftSize_orgin

      // 如果新图的宽度大于原图宽度势必 scaleW 大于 1; 如果小于则势必小于 1,因此只比较scaleW和scaleH谁更大即可
      const scaleW = (width / orginFileItem.orginPicWidth).toFixed(3) - 0
      const scaleH = (height / orginFileItem.orginPicHeight).toFixed(3) - 0
      // 自由裁切逻辑
      // if (width <= orginFileItem.orginPicWidth && height <= orginFileItem.orginPicHeight) {
      //   console.debug('新图小于原图')
      // } else {
      //   console.debug('新图大于原图', item)
      // }
      let isUseWH = ''
      if (scaleW === 1 || scaleH === 1) {
        if (scaleW === 1) {
          isUseWH = 'h' //等于1 取高的
        } else {
          isUseWH = 'w'
        }
      } else if (scaleW >= scaleH) {
        // 谁大就用谁的值
        isUseWH = 'w'
      } else {
        isUseWH = 'h'
      }

      if (isUseWH === 'w') {
        // 谁大就用谁的值
        useScale = scaleW
        ratio =
          (this.cssDynamicObj.realyWidth / designDraftSize_orgin[0]).toFixed(
            3
          ) - 0
      } else {
        useScale = scaleH
        ratio =
          (this.cssDynamicObj.realyHeight / designDraftSize_orgin[1]).toFixed(
            3
          ) - 0
      }

      const picRateW =
        (
          (width /
            (useScale *
              this.cssDynamicObj.realyWidth *
              orginFileItem.useScale)) *
          ratio
        ).toFixed(3) - 0 //保留小数点3位

      const picRateH =
        (
          (height /
            (useScale *
              this.cssDynamicObj.realyHeight *
              orginFileItem.useScale)) *
          ratio
        ).toFixed(3) - 0 //保留小数点3位

      console.debug(
        width,
        useScale,
        ratio,
        this.cssDynamicObj,
        picRateW,
        picRateH
      )

      return [picRateW, picRateH]
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(this.jionUrlSymbols),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    clickUploadBtn(flag) {
      this.showCropperPop = !flag
    },
    // async uploadToOss(data) {
    //   // const query = this.$route.query
    //   let params = null
    //   let pathUrl = null
    //   await https_getOssUploadInfor(this.axiosBaseUrl, this.$axios)
    //     .then((response) => {
    //       const res = response.data
    //       console.debug('https_getOssUploadInfor:', res)
    //       // 上传到oss
    //       params = {
    //         // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
    //         region: 'oss-cn-beijing',
    //         // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    //         accessKeyId: res.data.accessKeyId, //'STS.NTGB8nQVfw2FgqhHiTCp2YnBU',
    //         accessKeySecret: res.data.accessKeySecret, //'DtvoZfCR7kyEs1eg8dyzzmXEeNCbFHbnEJUmFxJmCgXP',
    //         // 从STS服务获取的安全令牌（SecurityToken）。
    //         stsToken: res.data.securityToken,
    //         // 填写Bucket名称。
    //         bucket: res.data.bucketName,
    //       }
    //       if (res.data.folder && res.data.bucketName) {
    //         let type = this.editFile.name.split('.')[1]
    //         let name = this.guid('m-platfrom-upload-file-xxxxxx-vxxx-4xxx')
    //         pathUrl = `${res.data.folder}/${name}.${type}`
    //       }
    //     })
    //     .catch((err) => {
    //       console.debug(err)
    //     })
    //   if (params && pathUrl) {
    //     await ossPutObject(
    //       params,
    //       data,
    //       pathUrl,
    //       this.uploadOssSuccess,
    //       this.uploadOssErr
    //     )
    //     // 上传完之后关闭弹窗
    //     this.closeCropperHandler()
    //   }
    // },
    // uploadOssSuccess(data, pathUrl, signUrl) {
    //   console.debug('uploadOssSuccess:', data, pathUrl, signUrl)
    //   if (this.fileData.fileList && this.fileData.fileList.length > 0) {
    //     this.fileData.fileList.forEach((item) => {
    //       if (item.uid === this.editFile.uid) {
    //         item.submitVal = pathUrl //后端只要不含oss域名路径的地址路径
    //         item.percentage = 100
    //         item.status = 'success'
    //         item.ossUrl = signUrl //oss生产的线上路径并且带签名
    //       }
    //     })
    //   }
    //   console.debug('this.fileData:', this.fileData)
    //   if (this.fileData.fileList && this.fileData.fileList.length === 1) {
    //     this.$emit('submitImageEvent', {
    //       absOssUrl: pathUrl,
    //       fullOssUrl: signUrl,
    //       uploadFileItem: this.item,
    //     })
    //   }
    //   if (
    //     this.fileData &&
    //     this.fileData.fileList &&
    //     this.fileData.fileList.length > 1
    //   ) {
    //     let absUrlArr = [],
    //       fullUrlArr = []
    //     this.fileData.fileList.forEach((item) => {
    //       absUrlArr.push(item.submitVal)
    //       fullUrlArr.push(item.ossUrl)
    //     })
    //     this.$emit('submitImageEvent', {
    //       fullOssUrl: fullUrlArr.join(this.jionUrlSymbols),
    //       absOssUrl: absUrlArr.join(this.jionUrlSymbols),
    //       uploadFileItem: this.item,
    //     })
    //   }
    // },
    uploadOssErr(err) {
      console.debug('uploadOssErr:', err)
    },
    handleRemove(uploadFile, uploadFiles) {
      console.debug('handleRemove:', uploadFile, uploadFiles)
    },
    loactionPreviewEventHandler(data) {
      // 将图片上传到oss服务器，
      // 抠图需要这个逻辑，将图片上传，服务器去抠图，然后将扣完的图吐给前端展示
      const { data: file } = data
      console.debug('loactionPreview:', file)
      if (this.customUploadCallback) {
        this.customUploadCallback(file)
      } else {
        let newFile = JSON.parse(JSON.stringify(file))
        newFile.name = this.computFileName(file.name)
        this.editFile = newFile
        let fileData = JSON.parse(JSON.stringify(this.fileData))
        if (fileData && fileData.fileList && fileData.fileList.length > 0) {
          fileData.fileList.forEach((item) => {
            if (item.uid === this.editFile.uid) {
              item.percentage = 40
              item.status = 'progress'
            }
          })
        }
        this.fileData = fileData
        this.uploadToOss(file.raw)
      }
    },
    async packageFileList(file) {
      // 将图片文件包装成 fileData 能使用的元素
      console.debug(file)
      const { base64, width, height } = await this.fileToBase64Async(file)
      const imageSizeKb = getBase64ImageSize(base64)
      console.debug('fileToBase64Async:', imageSizeKb)

      // 压缩图片目前只有jpg, jpeg生效
      const base64Header = base64 ? base64.split(';base64')[0] : ''
      let outputFormat = ''
      if (
        base64Header &&
        base64Header.indexOf('png') < 0 &&
        imageSizeKb > this.imageSizeKbLimitNum
      ) {
        // .png 格式的图片，该方法压缩不生效，非.png走这里（jpg,jpeg都可以压）
        outputFormat = base64Header.split(':')[1]
        const designDraftSize_orgin = this.fileData.designDraftSize_orgin
        // 宽高取最小值
        const maxValPx =
          designDraftSize_orgin[0] > designDraftSize_orgin[1]
            ? designDraftSize_orgin[1]
            : designDraftSize_orgin[0]
        compressBase64Image(
          base64,
          maxValPx, //压缩的宽度等于当前尺寸最小的一方
          maxValPx, //压缩的高度等于当前尺寸最小的一方
          outputFormat,
          1 //值范围：0~1之间； 压缩质量1，由于是压缩尺寸大小，所以质量暂时不压缩
        )
          .then((compressArr) => {
            this.base64ImgbackfillData(
              compressArr[0],
              compressArr[1],
              compressArr[2],
              imageSizeKb
            )
            // this.curUploadFileItem.base64 = compressArr[0]
            // this.curUploadFileItem.picWidth = compressArr[1]
            // this.curUploadFileItem.picHeight = compressArr[2]
            // console.debug('compressArr:', compressArr[1], compressArr[2])
            // let fileData = JSON.parse(JSON.stringify(this.fileData))
            // const fileList = fileData.fileList.map((fileItem) => {
            //   // console.debug(
            //   //   'fileData.fileList',
            //   //   fileData.fileList,
            //   //   this.curUploadFileItem,
            //   //   fileItem.uid === this.curUploadFileItem.uid
            //   // )
            //   if (fileItem.uid === this.curUploadFileItem.uid) {
            //     const picRateWH = this.updateImageDisplayRatio(
            //       compressArr[1],
            //       compressArr[2],
            //       fileItem
            //     )
            //     return {
            //       // 字段需要最后完善
            //       isShowPic: fileItem.isShowPic,
            //       name: fileItem.name,
            //       percentage: 0,
            //       status: 'location',
            //       size: file.size,
            //       useScale: 1, //更换素材图片默认比例是1
            //       orginPicWidth: this.curUploadFileItem.orginPicWidth,
            //       orginPicHeight: this.curUploadFileItem.orginPicHeight,
            //       orginPicRateWH: fileItem.orginPicRateWH,
            //       picWidth: this.curUploadFileItem.picWidth,
            //       picHeight: this.curUploadFileItem.picHeight,
            //       picRateW: picRateWH[0],
            //       picRateH: picRateWH[1],
            //       raw: file, //这里的file是input原始值
            //       uid: fileItem.uid,
            //       url: compressArr[0],
            //       // isDraggable: fileItem.isDraggable, //开关：控制是否可以拖拽
            //       className: fileItem.className,
            //       actState: '',
            //       styleItem: fileItem.styleItem,
            //       submitVal: '',
            //       absOssUrl: '',
            //     }
            //   } else {
            //     return fileItem
            //   }
            // })
            // fileData.fileList = fileList
            // fileData.type = 'changePic'
            // this.fileData = fileData
            // console.debug('更换完素材：', this.fileData)
          })
          .catch((error) => {
            console.error('压缩失败：', error)
          })
      } else {
        this.base64ImgbackfillData(base64, width, height, imageSizeKb)
      }

      // 没有压缩
      // this.curUploadFileItem.base64 = base64
      // this.curUploadFileItem.picWidth = width
      // this.curUploadFileItem.picHeight = height
      // let fileData = JSON.parse(JSON.stringify(this.fileData))
      // const fileList = fileData.fileList.map((fileItem) => {
      //   console.debug(
      //     'fileData.fileList',
      //     fileData.fileList,
      //     this.curUploadFileItem,
      //     fileItem.uid === this.curUploadFileItem.uid
      //   )
      //   if (fileItem.uid === this.curUploadFileItem.uid) {
      //     const picRateWH = this.updateImageDisplayRatio(
      //       width,
      //       height,
      //       fileItem
      //     )
      //     return {
      //       // 字段需要最后完善
      //       isShowPic: fileItem.isShowPic,
      //       name: fileItem.name,
      //       percentage: 0,
      //       status: 'location',
      //       size: file.size,
      //       useScale: 1, //更换素材图片默认比例是1
      //       orginPicWidth: this.curUploadFileItem.orginPicWidth,
      //       orginPicHeight: this.curUploadFileItem.orginPicHeight,
      //       orginPicRateWH: fileItem.orginPicRateWH,
      //       picWidth: this.curUploadFileItem.picWidth,
      //       picHeight: this.curUploadFileItem.picHeight,
      //       picRateW: picRateWH[0],
      //       picRateH: picRateWH[1],
      //       raw: file, //这里的file是input原始值
      //       uid: fileItem.uid,
      //       url: base64,
      //       // isDraggable: fileItem.isDraggable, //开关：控制是否可以拖拽
      //       className: fileItem.className,
      //       actState: '',
      //       styleItem: fileItem.styleItem,
      //       submitVal: '',
      //       absOssUrl: '',
      //     }
      //   } else {
      //     return fileItem
      //   }
      // })
      // fileData.fileList = fileList
      // fileData.type = 'changePic'
      // this.fileData = fileData
      // console.debug('更换完素材：', this.fileData)
    },
    base64ImgbackfillData(base64, width, height, base64KbSize) {
      // 回填数据
      this.curUploadFileItem.base64 = base64
      this.curUploadFileItem.picWidth = width
      this.curUploadFileItem.picHeight = height
      let fileData = JSON.parse(JSON.stringify(this.fileData))
      const fileList = fileData.fileList.map((fileItem) => {
        console.debug(
          'fileData.fileList',
          fileData.fileList,
          this.curUploadFileItem,
          fileItem.uid === this.curUploadFileItem.uid
        )
        if (fileItem.uid === this.curUploadFileItem.uid) {
          const picRateWH = this.updateImageDisplayRatio(
            width,
            height,
            fileItem
          )
          return {
            // 字段需要最后完善
            isShowPic: fileItem.isShowPic,
            name: fileItem.name,
            percentage: 0,
            status: 'location',
            size: base64KbSize, //单位：kb file.size,
            useScale: 1, //更换素材图片默认比例是1
            orginPicWidth: this.curUploadFileItem.orginPicWidth,
            orginPicHeight: this.curUploadFileItem.orginPicHeight,
            orginPicRateWH: fileItem.orginPicRateWH,
            picWidth: this.curUploadFileItem.picWidth,
            picHeight: this.curUploadFileItem.picHeight,
            picRateW: picRateWH[0],
            picRateH: picRateWH[1],
            // raw: file, //这里的file是input原始值
            uid: fileItem.uid,
            url: base64,
            // isDraggable: fileItem.isDraggable, //开关：控制是否可以拖拽
            className: fileItem.className,
            actState: '',
            styleItem: fileItem.styleItem,
            submitVal: '',
            absOssUrl: '',
          }
        } else {
          return fileItem
        }
      })
      fileData.fileList = fileList
      fileData.type = 'changePic'
      this.fileData = fileData
      console.debug('更换完素材：', this.fileData)
    },
    async base64ToImageWHpxAsync(imageBase64) {
      // 通过base64获取该base64图片的尺寸
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          // 获取图片宽度和高度
          const width = img.width
          const height = img.height
          console.log(`图片尺寸：宽度 = ${width}, 高度 = ${height}`)
          resolve({
            base64: imageBase64,
            width,
            height,
          })
        }
        img.src = imageBase64
      })
    },
    async fileToBase64Async(file) {
      // param {File} file
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            // 获取图片宽度和高度
            const width = img.width
            const height = img.height
            console.log(`图片尺寸：宽度 = ${width}, 高度 = ${height}`)
            resolve({
              base64: e.target.result,
              width,
              height,
            })
          }
          img.src = e.target.result
        }
      })
    },
    cropPreviewEventHandler(data) {
      // 将需要裁切的图片对象赋值给裁切组件，给 editFile 赋值
      const { data: file } = data
      console.debug('cropPreview:', file)
      let newFile = JSON.parse(JSON.stringify(file))
      newFile.name = this.computFileName(file.name)
      this.editFile = newFile
      this.cropperOpt = {
        autoCropWidth: file.orginPicWidth,
        autoCropHeight: file.orginPicHeight,
      }
      this.showCropperPop = true
    },
    localDownloadPic() {
      // 下载图片到本地
      if (this.currPicSize && this.currPicSize.length === 2) {
        // 清空画面多余的效果

        this.cancelActPic('init')

        function getDPR() {
          if (window.devicePixelRatio && window.devicePixelRatio > 1) {
            return window.devicePixelRatio
          }
          return 1
        }
        const dpi = getDPR()
        this.$nextTick(() => {
          html2canvas(this.$refs.workspace_view, {
            scale: dpi * 2,
            // useCORS: true,
            // width: this.currPicSize[0],
            // height: this.currPicSize[1],
            // windowWidth: this.$refs.workspace_view.scrollWidth, //开启这个生产的图片会变形
            // windowHeight: this.$refs.workspace_view.scrollHeight,
          }).then((canvas) => {
            // 默认返回的图片尺寸: 设置的宽高*浏览器设备像素比率

            // const width = canvas.width
            // const height = canvas.height
            const newWidth = this.currPicSize[0] // 新的宽度
            const newHeight = this.currPicSize[1] // 根据等比例缩放的新高度

            // 创建一个新的canvas来绘制新尺寸的图片
            const newCanvas = document.createElement('canvas')
            newCanvas.style.width = `${newWidth}px`
            newCanvas.style.height = `${newHeight}px`
            newCanvas.width = newWidth
            newCanvas.height = newHeight
            const ctx = newCanvas.getContext('2d')
            // ctx.scale(0.5, 0.5)
            ctx.drawImage(canvas, 0, 0, newWidth, newHeight)
            const imageBase64 = newCanvas.toDataURL('image/jpg')

            // 清除没用的dom
            if (newCanvas.remove) {
              newCanvas.remove()
            } else if (newCanvas.parentNode) {
              newCanvas.parentNode.removeChild(newCanvas)
            }
            // 下载放大后的图片
            this.imageSaveLocal(imageBase64)

            // 重置 fileData.type
            this.fileData.type = ''
          })
        })
      }
    },
    imageSaveLocal(imageBase64) {
      const aElement = document.createElement('a')
      aElement.href = imageBase64
      aElement.download =
        this.posterBaseInfor && this.posterBaseInfor.posterName
          ? `${this.posterBaseInfor.posterName}.jpg`
          : '数据海报.jpg'
      aElement.click()
      if (aElement.remove) {
        aElement.remove()
      } else if (aElement.parentNode) {
        aElement.parentNode.removeChild(aElement)
      }
    },
    async cutoutImage(picBase64Obj) {
      // 智能抠图接口
      let params = {
        picWeight: picBase64Obj.width,
        picHeight: picBase64Obj.height,
        pic: picBase64Obj.base64,
      }
      await https_dataPoster_cutoutImage(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(res.data)
            //保存用户设置成功
            const curr_cutoutImageArr = JSON.parse(
              JSON.stringify(this.curr_cutoutImageArr)
            )
            curr_cutoutImageArr[1].url = res.data
            this.curr_cutoutImageArr = curr_cutoutImageArr
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.workspace_leftContainer {
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  /* flex: 1; */
  width: calc(100% - 26.388vw - 1.388vw);
  padding: 3.47vw 0;
  border: 1px solid var(--mixtmt_greyColor8);
  background-color: var(--mixtmt_greyColor14);
  .main_left {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    background-color: var(--mixtmt_whiteColor);
  }
  .workspace_topAbs {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 0.694vw;
    top: 0;
    z-index: 100;
    width: calc(100% - 1.388vw);
    height: 3.47vw;
    border-bottom: 1px solid var(--mixtmt_greyColor8);
    .topLeft,
    .topRight {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
    }
    .topLeft {
      justify-content: flex-start;
    }
    .topRight {
      justify-content: flex-end;
      .picSizeSelect {
        width: 9.72vw;
      }
    }
    .btnRow {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      .btnRow_title {
        padding-right: 0.416vw;
      }
    }
  }
  .workspace_bottomAbs {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 0.694vw;
    bottom: 0;
    z-index: 100;
    width: calc(100% - 1.388vw);
    height: 3.47vw;
    border-top: 1px solid var(--mixtmt_greyColor8);
    .bottomLeft,
    .bottomRight {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
    }
    .bottomLeft,
    .topLeft {
      justify-content: flex-start;
    }
    .bottomRight,
    .topRight {
      justify-content: flex-end;
    }
  }
  .mr15 {
    margin-right: 1.11vw;
  }
  .workspace_btn {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    width: 6.94vw;
    height: 2.083vw;
    border: 1px solid var(--mixtmt_greyColor4);
    background-color: var(--mixtmt_whiteColor);
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor4);
    border-radius: 0.208vw;
  }
  .workspace_main {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    background-color: var(--mixtmt_greyColor14);
    .defaultPic {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .pic_icon {
        font-size: 2.778vw;
        color: var(--mixtmt_greyColor6);
      }
      .textArea {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        font-size: 1.11vw;
        line-height: 2.083vw;
        color: var(--mixtmt_greyColor2);
        .highColor {
          color: var(--mixtmt_subColor1_1);
        }
      }
    }
    .workspace_view {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      overflow: hidden;
      font-family: 'dataPosterFont';
      &.disable-touch-callout {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently not supported by any browser */
      }
    }
  }
  .dialog_pop {
    position: absolute;
    left: 0;
    top: 0;
  }
  .cropperPop {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2100;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    transform: translate(-50%, -50%);
    & > div {
      width: 100%;
    }
  }

  .editPicRowItem_list {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .cutoutImage_container {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    .picVeiwList {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .picImageSpan {
        position: relative;
        width: calc(50% - 0.694vw);
        padding-top: 30%;
        background-color: var(--mixtmt_greyColor8);
        img {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          object-fit: contain;
          overflow: hidden;
        }
      }
    }
    .btnList {
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: auto;
      padding: 1.1vw 0;
      .btnArea {
        width: calc(50% - 0.694vw);
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .picType {
          width: 100%;
          font-size: 1.25vw;
          height: 2.68vw;
          text-align: center;
          color: var(--mixtmt_greyColor2);
          font-weight: bold;
        }
        .workspace_btn {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: center;
          width: 6.94vw;
          height: 2.083vw;
          border: 1px solid var(--mixtmt_subColor1_1);
          background-color: var(--mixtmt_subColor1_1);
          font-size: 0.972vw;
          color: var(--mixtmt_whiteColor);
          border-radius: 0.208vw;
          &.notClick {
            border: 1px solid var(--mixtmt_greyColor12);
            background-color: var(--mixtmt_greyColor12);
            color: var(--mixtmt_greyColor2);
          }
        }
      }
    }
  }
}
.mixtmt_pc .workspace_leftContainer {
  .main_left {
    .workspace_topAbs,
    .workspace_bottomAbs {
      .workspace_btn {
        &:hover {
          border: 1px solid var(--mixtmt_mainColor);
          background-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
          cursor: pointer;
        }
      }
    }
  }
  .btnList {
    .btnArea {
      .workspace_btn {
        &:hover:not(.notClick) {
          border: 1px solid var(--mixtmt_mainColor);
          background-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.workspace_leftContainer {
}
.mixtmt_pc,
.mixtmt_ipad {
  .workspace_leftContainer {
    .el-input-number {
      width: 9.72vw;
      height: 2.083vw;
      line-height: 2.083vw;
      .el-input .el-input__inner {
        padding-left: 2.083vw;
        padding-right: 2.083vw;
        font-size: 0.972vw;
        line-height: 2.083vw;
        height: 2.083vw;
        border-radius: 0.278vw;
      }
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 2.083vw;
      font-size: 0.903vw;
      height: calc(2.083vw - 1px - 1px);
      line-height: calc(2.083vw - 1px - 1px);
    }
  }
}
</style>
